import { ibkApi } from '@ibk/shared-config';
export const buildCreateOrderMutation = ({ contractId, body }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders`,
    method: 'POST',
    body,
});
export const transformCreateOrderResponse = (response) => response.result;
export const buildGetOrderQuery = ({ contractId, orderId }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}`,
    method: 'GET',
});
export const transformGetOrderResponse = (response) => response.result;
export const buildListOrdersQuery = ({ contractId, limit, offset, sort, search, protocol, year, month, screenStatus, productId, }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders`,
    method: 'GET',
    params: {
        ...(limit !== undefined && { limit }),
        ...(offset !== undefined && { offset }),
        ...(sort && { sort }),
        ...(search && { search }),
        ...(protocol && { protocol }),
        ...(year !== undefined && { year }),
        ...(month !== undefined && { month }),
        ...(screenStatus && { screenStatus }),
        ...(productId?.length && { productId }),
    },
});
export const transformListOrdersResponse = (response) => response.result;
export const buildUpdateOrderMutation = ({ contractId, orderId, body }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}`,
    method: 'PATCH',
    body,
});
export const transformUpdateOrderResponse = (response) => response.result;
export const buildCancelOrderMutation = ({ contractId, orderId }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}/cancel`,
    method: 'POST',
});
export const transformCancelOrderResponse = (response) => response.result;
export const buildListOrderBeneficiariesQuery = ({ contractId, orderId, limit, offset, name, }) => ({
    url: `/v1/benefits/contracts/${contractId}/orders/${orderId}/beneficiaries`,
    method: 'GET',
    params: {
        ...(limit !== undefined && { limit }),
        ...(offset !== undefined && { offset }),
        ...(name && { name }),
    },
});
export const transformListOrderBeneficiariesResponse = (response) => response.result;
export const contractOrdersApi = ibkApi.injectEndpoints({
    endpoints: build => ({
        createEmissorOrder: build.mutation({
            query: buildCreateOrderMutation,
            transformResponse: transformCreateOrderResponse,
            invalidatesTags: (_result, _error, { contractId }) => [{ type: 'EmissorOrders', id: contractId }],
        }),
        getEmissorOrder: build.query({
            query: buildGetOrderQuery,
            transformResponse: transformGetOrderResponse,
            providesTags: (_result, _error, { orderId }) => [{ type: 'EmissorOrders', id: orderId }],
        }),
        listEmissorOrders: build.query({
            query: buildListOrdersQuery,
            transformResponse: transformListOrdersResponse,
            providesTags: (_result, _error, { contractId }) => [{ type: 'EmissorOrders', id: contractId }],
        }),
        listEmissorOrderBeneficiaries: build.query({
            query: buildListOrderBeneficiariesQuery,
            transformResponse: transformListOrderBeneficiariesResponse,
            providesTags: (_result, _error, { orderId }) => [{ type: 'EmissorOrders', id: `${orderId}-beneficiaries` }],
        }),
        updateEmissorOrder: build.mutation({
            query: buildUpdateOrderMutation,
            transformResponse: transformUpdateOrderResponse,
            invalidatesTags: (_result, _error, { contractId, orderId }) => [
                { type: 'EmissorOrders', id: contractId },
                { type: 'EmissorOrders', id: orderId },
            ],
        }),
        cancelEmissorOrder: build.mutation({
            query: buildCancelOrderMutation,
            transformResponse: transformCancelOrderResponse,
            invalidatesTags: (_result, _error, { contractId, orderId }) => [
                { type: 'EmissorOrders', id: contractId },
                { type: 'EmissorOrders', id: orderId },
            ],
        }),
    }),
    overrideExisting: false,
});
export const { useCreateEmissorOrderMutation, useGetEmissorOrderQuery, useLazyGetEmissorOrderQuery, useListEmissorOrdersQuery, useLazyListEmissorOrdersQuery, useListEmissorOrderBeneficiariesQuery, useLazyListEmissorOrderBeneficiariesQuery, useUpdateEmissorOrderMutation, useCancelEmissorOrderMutation, } = contractOrdersApi;
